import { render, staticRenderFns } from "./PgNavbar.vue?vue&type=template&id=030c6574&scoped=true&"
import script from "./PgNavbar.vue?vue&type=script&lang=js&"
export * from "./PgNavbar.vue?vue&type=script&lang=js&"
import style0 from "./PgNavbar.vue?vue&type=style&index=0&id=030c6574&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030c6574",
  null
  
)

export default component.exports